import axios from "axios";


const getStatistics = () => {
  //return axios.get(`${process.env.REACT_APP_API_BASE_URL}/statistic?userId=${userId}`)
  return axios.get(`${process.env.REACT_APP_API_BASE_URL}/statistic`)
  .then((response) => {
    return response.data;
  })
};

export default { getStatistics };
